@if (isAuthenticated) {
  <app-version-nav></app-version-nav>
} @else {
  <app-header></app-header>
}
<div class="legal-container">
  <div class="legal-content">
    <h1>Cookie Policy</h1>
    <p class="last-updated">Last Updated: {{ currentDate | date:'longDate' }}</p>

    <section class="legal-section">
      <h2>1. What Are Cookies</h2>
      <p>
        Cookies are small text files that are placed on your computer or mobile device when you visit 
        a website. They are widely used to make websites work more efficiently and provide information 
        to the website owners.
      </p>
    </section>

    <section class="legal-section">
      <h2>2. How We Use Cookies</h2>
      <p>
        AIOptima uses cookies to enhance your experience on our platform. We use cookies for the 
        following purposes:
      </p>
      <ul>
        <li><strong>Essential Cookies:</strong> Required for the platform to function properly</li>
        <li><strong>Authentication Cookies:</strong> To keep you logged in and maintain your session</li>
        <li><strong>Preference Cookies:</strong> To remember your settings and preferences</li>
        <li><strong>Analytics Cookies:</strong> To understand how you use our platform and improve it</li>
        <li><strong>Performance Cookies:</strong> To monitor platform performance and optimize loading times</li>
      </ul>
    </section>

    <section class="legal-section">
      <h2>3. Types of Cookies We Use</h2>
      
      <h3>3.1 Strictly Necessary Cookies</h3>
      <p>
        These cookies are essential for you to browse the website and use its features. Without these 
        cookies, services you have asked for cannot be provided.
      </p>

      <h3>3.2 Functionality Cookies</h3>
      <p>
        These cookies allow the website to remember choices you make and provide enhanced, more 
        personal features.
      </p>

      <h3>3.3 Analytics Cookies</h3>
      <p>
        These cookies help us understand how visitors interact with our website by collecting and 
        reporting information anonymously.
      </p>

      <h3>3.4 Performance Cookies</h3>
      <p>
        These cookies collect information about how you use our website, such as which pages you visit 
        most often, to help us improve the performance of our website.
      </p>
    </section>

    <section class="legal-section">
      <h2>4. Third-Party Cookies</h2>
      <p>
        In addition to our own cookies, we may also use various third-party cookies to report usage 
        statistics of the Service and refine marketing efforts. These third-party cookies are used for:
      </p>
      <ul>
        <li>Analytics and performance monitoring</li>
        <li>Service functionality and integration</li>
      </ul>
    </section>

    <section class="legal-section">
      <h2>5. Managing Cookies</h2>
      <p>
        You have the right to decide whether to accept or reject cookies. You can exercise your cookie 
        rights by setting your preferences in your browser settings. Most browsers allow you to:
      </p>
      <ul>
        <li>See what cookies you have and delete them individually</li>
        <li>Block third-party cookies</li>
        <li>Block cookies from particular sites</li>
        <li>Block all cookies from being set</li>
        <li>Delete all cookies when you close your browser</li>
      </ul>
      <p>
        Please note that if you choose to block or delete cookies, some features of our platform may 
        not function properly.
      </p>
    </section>

    <section class="legal-section">
      <h2>6. Cookie Duration</h2>
      <p>We use both session cookies and persistent cookies:</p>
      <ul>
        <li><strong>Session Cookies:</strong> Temporary cookies that expire when you close your browser</li>
        <li><strong>Persistent Cookies:</strong> Remain on your device for a set period or until you delete them</li>
      </ul>
    </section>

    <section class="legal-section">
      <h2>7. Updates to This Cookie Policy</h2>
      <p>
        We may update this Cookie Policy from time to time to reflect changes in technology, legislation, 
        or our operations. We will notify you of any material changes by posting the new Cookie Policy 
        on this page.
      </p>
    </section>

    <section class="legal-section">
      <h2>8. Contact Us</h2>
      <p>
        If you have any questions about our use of cookies or this Cookie Policy, please contact us 
        through our platform or support channels.
      </p>
    </section>
  </div>
</div>
